module.exports = __webpack_public_path__ + "img/dt1.73724a29.png";